export default __webpack_public_path__ + "static/media/Earrings.ce52c84c.jpg";